import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function PlaninaIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="PlaninaIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <polygon fill="currentcolor" points="55,30 44.8,44.4 55.7,59.7 49.7,59.7 36.9,41.5 20.7,64.5 79.3,64.5 "/>
    </svg>
  </SvgIcon>
}

export default PlaninaIcon;
